// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InvalidToken_wrapper__G5dVr","title":"InvalidToken_title__33X2f","backBtn":"InvalidToken_backBtn__3w5KW"};